import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_user_details = async (id) => {
  const requestObj = {
    path: `api/client/detail_client_token/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
